import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import { AngularCsv } from 'angular7-csv/dist/Angular-csv';
import { LoanResortsService } from 'app/services/loan-resorts.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import * as moment from 'moment';
import { of } from 'rxjs';
import {
  mergeMap,
  filter,
  tap,
  map,
  toArray,
  pluck,
  switchMap,
} from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-approved-by-commodity',
  templateUrl: './approved-by-commodity.component.html',
  styleUrls: ['./approved-by-commodity.component.css'],
})
export class ApprovedByCommodityComponent implements OnInit {
  commodity: string;

  user: any;
  p: number = 1;
  itemsPerPage = 10;
  currentPage = 1;
  totalRec;
  lApplications: Array<any> = [];
  dataRec: Boolean = false;
  dataToShow: Array<any> = [];
  appObj: any;
  filterWnameArr: Array<any> = [];
  toDate: any;
  fromDate: any;
  loanAppsLoaded: Boolean = false;

  emailForm: FormGroup;
  sendingEmail: boolean = false;

  isOneWeekFilter: boolean = false;
  isCurrentMonthFilter: boolean = false;
  isOneMonthFilter: boolean = false;
  isCurrentYearFilter: boolean = false;
  isOneYearFilter: boolean = false;

  setQuery = null;

  runningQuery: any;

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private lservice: LoanResortsService,
    private toastr: ToastrService
  ) {
    this.commodity = this.route.snapshot.paramMap.get('commodity');
  }

  disableAllFilterBoolean() {
    this.isOneWeekFilter = false;
    this.isCurrentMonthFilter = false;
    this.isOneMonthFilter = false;
    this.isCurrentYearFilter = false;
    this.isOneYearFilter = false;
  }

  setFilterBoolean(range) {
    this.disableAllFilterBoolean();
    switch (range) {
      case '1W':
        this.isOneWeekFilter = true;
        return;
      case 'MTD':
        this.isCurrentMonthFilter = true;
        return;
      case '1M':
        this.isOneMonthFilter = true;
        return;
      case 'YTD':
        this.isCurrentYearFilter = true;
        return;
      case '1Y':
        this.isOneYearFilter = true;
        return;
    }
  }

  ngOnInit() {
    this.emailForm = this.fb.group({
      email: [
        '',
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,}$'),
        ],
      ],
    });

    this.route.queryParams
      .pipe(
        switchMap((value) => of(value)),
        tap((value) => this.setFilterBoolean(value.range)),
        tap((value) => {
          if (value.range) {
            this.fromDate = null;
            this.toDate = null;
          } else {
            this.fromDate = value.fromDate;
            this.toDate = value.toDate;
          }
        }),
        map((value) => {
          const params = { ...value };
          this.p = params.page || 1;

          params.page = this.p;
          params.limit = this.itemsPerPage;
          return params;
        }),
        map((value) => {
          let query: any = {
            page: value.page,
            limit: value.limit,
          };

          if (value.fromDate && value.toDate) {
            query.fromDate = value.fromDate;
            query.toDate = value.toDate;
          }

          return query;
        })
      )
      .subscribe((query) => {
        console.log('query', query);
        this.getLoanApplicationReports(query);
      });
  }

  onEmailSubmit() {
    const { fromDate, toDate, range } = this.route.snapshot.queryParams;

    const query: any = {
      sendBy: 'email',
      email: this.emailForm.get('email').value,
      fileName: `${range ? `${range}_` : ''}MIS_${
        this.commodity
      }_Approved_Loans-${new Date().toDateString()}`,
      reportName: `${this.commodity} Approved Loans`,
    };

    if (fromDate && toDate) {
      query.fromDate = fromDate;
      query.toDate = toDate;
    }

    this.loanAppsLoaded = false;
    this.sendingEmail = true;

    this.lservice
      .getApprovedLoanUnderCommodity(this.commodity, query)
      .subscribe(
        () => {
          this.sendingEmail = false;
          this.loanAppsLoaded = true;
          this.toastr.success(
            `Email sent to  ${this.emailForm.get('email').value}`
          );
        },
        () => {
          this.sendingEmail = false;
          this.loanAppsLoaded = true;
          this.toastr.error('Cant send email');
        }
      );
  }

  onRowClick(value) {
    this.router.navigate(['/loanapplicationdetails'], {
      queryParams: {
        id: value._id,
        uId: value.submittedBy,
      },
    });
  }

  onResetClick() {
    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity]);
  }

  getReportbyDateRange() {
    if (!this.fromDate || !this.toDate) {
      return;
    }

    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity], {
      queryParams: {
        fromDate: this.fromDate,
        toDate: this.toDate,
        page: 1,
      },
    });
  }

  isInArray(value, array) {
    return array.indexOf(value) > -1;
  }

  getLoanApplicationReports(query: any = {}) {
    if (this.runningQuery) this.runningQuery.unsubscribe();

    this.lApplications = [];
    this.dataToShow = [];

    this.loanAppsLoaded = false;
    this.runningQuery = this.lservice
      .getApprovedLoanUnderCommodity(this.commodity, query)
      .subscribe((data) => {
        this.loanAppsLoaded = true;
        this.dataRec = true;
        this.lApplications = data['data'];
        this.dataToShow = data['data'];
        this.totalRec = data['numberOfloans'];

        for (let i = 0; i < this.dataToShow.length; i++) {
          this.dataToShow[i]['tprice'] =
            this.dataToShow[i]['depositApp']['depositQty'] *
            this.dataToShow[i]['depositApp']['perUnitValue'];
          if (
            !this.isInArray(
              this.lApplications[i]['warehouseName'],
              this.filterWnameArr
            )
          ) {
            this.filterWnameArr.push(this.lApplications[i]['warehouseName']);
          }
        }
      });
  }

  fileWriteObj(data) {
    return {
      // 'Application ID': data._id,
      'WHR Number':
        data.depositApp && data.depositApp.mswcReceiptId
          ? data.depositApp.mswcReceiptId
          : data.depositApp.blockchainReceiptId,
      State: data.address.state,
      'Name of Borrower': data.applicantName,
      'Loan Application Date': moment(data.timestamp).format('MMM D, YYYY'),
      'Commodity Type':
        data.commodityId && data.commodityId.name
          ? data.commodityId.name
          : data.commodityName,
      'Net Quantity': `${data.depositQty} ${data.depositUom}`,
      'Unit Price': data.depositApp ? data.depositApp.perUnitValue : 'nil',
      'Value of Stock': data.totalReceiptValue,
      'Approved Loan Amount': data.approved ? data.approved.loanAmount : 'nil',
      'Transaction Price': data.tprice || 'nil',
      'Loan Application Status': data.applicationStatus,
      'CMA Appointment Status': data.cmaAppointmentstatus,
    };
  }

  downloadFile(fileType = 'csv') {
    const { fromDate, toDate } = this.route.snapshot.queryParams;

    const query: any = {};

    if (fromDate && toDate) {
      query.fromDate = fromDate;
      query.toDate = toDate;
    }

    this.loanAppsLoaded = false;
    this.lservice
      .getApprovedLoanUnderCommodity(this.commodity, query)
      .pipe(
        pluck('data'),
        mergeMap((values: any[]) => of(...values)),
        map((value) => {
          const loanApp = { ...value };
          loanApp.tprice =
            loanApp.depositApp.depositQty * loanApp.depositApp.perUnitValue;

          return this.fileWriteObj(loanApp);
        }),
        toArray()
      )
      .subscribe(
        (loanApps: any) => {
          this.loanAppsLoaded = true;
          if (fileType === 'pdf') {
            this.writeToPDF(loanApps);
          } else {
            this.writeToCSV(loanApps);
          }
        },
        () => {
          this.loanAppsLoaded = true;
        }
      );
  }

  print() {}

  writeToCSV(data) {
    let headers = [];
    if (data.length) {
      headers = Object.keys(data[0]);
    }

    const options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: false,
      headers: headers,
      showTitle: false,
      title: 'name',
      useBom: false,
      removeNewLines: true,
      noDownload: false,
    };

    new AngularCsv(
      data,
      'MIS_' +
        this.commodity +
        '_Approved_Loan_Applications-' +
        new Date().toDateString(),
      options
    );
  }

  writeToPDF(data) {
    let headers = [];
    if (data.length) {
      headers = Object.keys(data[0]);
    }

    const doc = new jsPDF('landscape');
    const rows = data.map((d) => headers.map((h) => d[h]));

    doc.setFontSize(9);
    doc.autoTable(headers, rows);
    doc.save(
      'MIS_' +
        this.commodity +
        '_Approved_Loan_Applications-' +
        new Date().toDateString() +
        '.pdf'
    );
  }

  getOneWeekReport() {
    const today = moment().format('YYYY-MM-DD');
    const weekStart = moment().subtract(1, 'weeks').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity], {
      queryParams: {
        fromDate: weekStart,
        toDate: today,
        range: '1W',
        page: 1,
      },
    });
  }

  getCurrentMonthReport() {
    const today = moment().format('YYYY-MM-DD');
    const monthStart = moment().startOf('month').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity], {
      queryParams: {
        fromDate: monthStart,
        toDate: today,
        range: 'MTD',
        page: 1,
      },
    });
  }

  getOneMonthReport() {
    const today = moment().format('YYYY-MM-DD');
    const monthStart = moment().subtract(1, 'months').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity], {
      queryParams: {
        fromDate: monthStart,
        toDate: today,
        range: '1M',
        page: 1,
      },
    });
  }

  getCurrentYearReport() {
    const today = moment().format('YYYY-MM-DD');
    const yearStart = moment().startOf('year').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity], {
      queryParams: {
        fromDate: yearStart,
        toDate: today,
        range: 'YTD',
        page: 1,
      },
    });
  }

  getOneYearReport() {
    const today = moment().format('YYYY-MM-DD');
    const yearStart = moment().subtract(1, 'years').format('YYYY-MM-DD');

    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity], {
      queryParams: {
        fromDate: yearStart,
        toDate: today,
        range: '1Y',
        page: 1,
      },
    });
  }

  getNewPage($event) {
    this.router.navigate(['/approved-loan-reports-cmdt', this.commodity], {
      queryParams: {
        page: $event,
      },
      queryParamsHandling: 'merge',
    });
  }

  goBack() {
    this.router.navigate(['/approved-loan-reports-cmdt']);
  }
}
